import { UsuarioModel } from './UsuarioModel'
import { ModuloModel } from './ModuloModel'
import { AvaliacaoQuestaoModel } from './AvaliacaoQuestaoModel'

export enum TIPO_AVALIACAO {
  AVALIACAO = 'AVALIACAO',
  SIMULADO = 'SIMULADO',
}

export enum STATUS_AVALIACAO {
  EM_ANDAMENTO = 'EM_ANDAMENTO',
  REPROVADA = 'REPROVADA',
  APROVADA = 'APROVADA',
  NAO_CONCLUIDA = 'NAO_CONCLUIDA',
}

export class AvaliacaoModel {
  id: number
  pontuacao: number
  duracao: number
  usuarioId: number
  usuario: UsuarioModel
  moduloId: number
  modulo: ModuloModel
  avaliacoesQuestoes: AvaliacaoQuestaoModel[]
  tipo: TIPO_AVALIACAO
  status: STATUS_AVALIACAO
  createdAt: any
}
